module.exports = __webpack_public_path__ + "img/ring_g_skip_0_null@2x.f13145e0.png";